import { schemas } from '#oaf_schema.registry';
import { createStore } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT } from '~/config';
import { ListingEditorStatus } from '~/modules/utilities/listingEditorStatus';
import { TECHNOLOGY_EXTENSION_MAP } from '~/modules/utilities/schemaUtilities';

// Creating our own type for consultant listing since, on the MERCURY (UI) this type does not match the OAF type.
// In mercury some properties can be removed by the users (oaf wouldn't allow that) so in the "MERCURY"
// types, we can define which properties we can expect to be empty. This makes TS happy

const initialState = {
  baseGet: () => ({
    listing: null
  }),
  type: 'consultant',
  data: schemas['listing/extensions/consultant/listings/Listing'].new()
};
export const consultantListingStore = createStore(initialState, (set, _get) => ({
  reset() {
    set(function reset() {
      return initialState;
    });
  },
  initialize(baseGet, editorStatus, extensionData = initialState.data, {
    marketplace
  }) {
    set(function initialize(draft) {
      var _baseGet$listing$tech, _baseGet$listing;
      draft.baseGet = baseGet;
      draft.type = (_baseGet$listing$tech = (_baseGet$listing = baseGet().listing) === null || _baseGet$listing === void 0 ? void 0 : _baseGet$listing.technology) !== null && _baseGet$listing$tech !== void 0 ? _baseGet$listing$tech : initialState.type;
      draft.data = schemas[TECHNOLOGY_EXTENSION_MAP[draft.type]].new(extensionData);

      // Initialize highlights
      if (draft.data.highlights.length === 0) {
        draft.data.highlights.push('');
      }

      // Initialize marketplace (it can only be set once on new listings, cannot be changed on existing listings)
      if (marketplace && editorStatus === ListingEditorStatus.NewListing) {
        draft.data.marketplace = marketplace;
      }
    });
  },
  /* istanbul ignore next */
  setTagLine(tagLine) {
    set(function setTagLine(draft) {
      draft.data.searchBlurb = tagLine;
    });
  },
  /* istanbul ignore next */
  setCategories(listingCategories) {
    set(function setCategories(draft) {
      draft.data.listingCategories = listingCategories;
    });
  },
  addHighlight() {
    set(function addHighlight(draft) {
      if (draft.data.highlights) {
        draft.data.highlights.push('');
      } else {
        draft.data.highlights = [''];
      }
    });
  },
  changeHighlight(index, value) {
    set(function changeHighlight(draft) {
      if (draft.data.highlights) {
        draft.data.highlights[index] = value;
      }
    });
  },
  removeHighlight(index) {
    set(function removeHighlight(draft) {
      if (draft.data.highlights) {
        draft.data.highlights.splice(index, 1);
      }
    });
  },
  /* istanbul ignore next */
  setLanguages(languages) {
    set(function setLanguages(draft) {
      draft.data.languages = languages;
    });
  },
  /* istanbul ignore next */
  setLearnMoreURL(url) {
    set(function setLearnMoreURL(draft) {
      draft.data.learnMoreURL = url;
    });
  },
  /* istanbul ignore next */
  setIsPledgeOnePercent(isOnePercentPledge) {
    set(function setIsPledgeOnePercent(draft) {
      draft.data.isPledge1Percent = isOnePercentPledge;
    });
  },
  /* istanbul ignore next */
  setIsDiverseOwnedBusiness(isDiverseOwnedBusiness) {
    set(function setIsDiverseOwnedBusiness(draft) {
      draft.data.isDiverseOwnedBusiness = isDiverseOwnedBusiness;
    });
  },
  /* istanbul ignore next */
  setDiverseOwnedBusinessURL(diverseOwnedBusinessURL) {
    set(function setDiverseOwnedBusinessURL(draft) {
      draft.data.diverseOwnedBusinessURL = diverseOwnedBusinessURL;
    });
  }
}), 'CONSULTANT_LISTING', IS_DEVELOPMENT);
export function selectConsultantListingData(state) {
  return state.data;
}
export function selectSearchBlurb(state) {
  return state.data.searchBlurb || '';
}
export function selectHighlights(state) {
  return state.data.highlights || '';
}
export function selectLearnMoreURL(state) {
  return state.data.learnMoreURL || '';
}